<template>
  <div id="commitment-container" class="commitment-container">
    <div id="sticky-carousel" class="progressbar">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <carousel
              ref="carouselComponent"
              :rotate-tag="{ __eventType: 'click' }"
              :auto-rotate="false"
              go-to-slide-text="Go to slide"
              pause-carousel-text="pause carousel"
              play-carousel-text="play carousel"
              previous-slide-text="previous slide"
              next-slide-text="next slide"
              :navigation-enabled="true"
              :pagination-enabled="false"
              :per-page="
                commitmentData.commitments.length > 7 ? 7 : commitmentData.commitments.length
              "
              :scroll-per-page="false"
              :infinite="false"
            >
              <slide v-for="(item, index) in commitmentData.commitments" :key="index">
                <span
                  :class="{ 'index-highlight': 'commitment' + index == activeId }"
                  @click="setSelected(index)"
                >
                  <a href="#" :class="{ highlight: 'commitment' + index == activeId }">{{
                    item.title
                  }}</a>
                </span>
              </slide>
            </carousel>
          </div>
        </div>
      </div>
    </div>
    <div style="clear: both"></div>
    <div
      v-for="(item, index) in commitmentData.commitments"
      :id="'commitment' + index"
      :key="index"
      :class="{ 'bg-highlight': 'commitment' + index == activeId }"
      class="commitment-bottom-container"
    >
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <div v-if="index % 2 === 0" class="row">
              <div class="col-md-6">
                <div class="commitment-text-left">
                  <div class="bg-text-left" v-html="item.text"></div>
                  <!--<p v-html="item.text"></p>-->
                </div>
              </div>
              <div class="col-md-6">
                <div class="commitment-image">
                  <img :src="item.image" :alt="item.title" />
                </div>
              </div>
            </div>
            <div v-else class="row">
              <div class="col-md-6 col-md-push-6">
                <div class="commitment-text-right">
                  <!--<p v-html="item.text"></p>-->
                  <div class="bg-text-right" v-html="item.text"></div>
                </div>
              </div>
              <div class="col-md-6 col-md-pull-6">
                <div class="commitment-image">
                  <img :src="item.image" :alt="item.title" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';
import VueScrollTo from 'vue-scrollto';
export default {
  name: 'commitments',
  props: {
    commitmentData: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      selectedIndex: -1,
      currentId: -1,
      activeId: '',
      pause: false,
    };
  },
  mounted() {
    this.handleDebouncedScroll = debounce(this.handleScroll, 15);
    window.addEventListener('scroll', this.handleDebouncedScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleDebouncedScroll);
  },
  methods: {
    handleScroll() {
      this.isElementInView();
      var rect = document.getElementById('sticky-carousel').getBoundingClientRect();
      var commitmentsRect = document
        .getElementsByClassName('description')[0]
        .getBoundingClientRect().top;
      let footerRect = document
        .getElementsByClassName('mixa-redesign-footer-mainnav')[0]
        .getBoundingClientRect().top;
      if (rect.top < 0 && footerRect > 130)
        document.getElementById('sticky-carousel').classList.add('sticky');
      else if ((commitmentsRect > 50 && commitmentsRect < 390) || footerRect < 50)
        document.getElementById('sticky-carousel').classList.remove('sticky');
    },
    isElementInView() {
      const els = document.querySelectorAll('.commitment-bottom-container');
      els.forEach((el) => {
        const elTop = el.getBoundingClientRect().top - 200;
        const elBottom = el.getBoundingClientRect().bottom;
        if (elTop <= 0 && elBottom >= 0 && this.activeId != el.id) {
          this.activeId = el.id;
          let indexNumber = parseInt(el.id.match(/\d/g).join(''));
          if (this.currentId >= indexNumber && !this.pause) {
            this.$refs.carouselComponent.advancePage('backward');
          } else if (indexNumber > 6 && !this.pause) {
            this.$refs.carouselComponent.advancePage('forward');
          }
          this.currentId = indexNumber;
        }
      });
    },
    setSelected(index) {
      this.activeId = 'commitement' + index;
      this.pause = true;
      var self = this;
      VueScrollTo.scrollTo(`#commitment${index}`, 500, {
        easing: 'ease',
        offset: -170,
        onDone: function () {
          //onDone callBack is called before scrolling end.So we added setTimeout function here..
          setTimeout(function () {
            self.pause = false;
          }, 300);
        },
      });
    },
  },
};
</script>
